module.exports = __webpack_public_path__ + "img/logo.5da63b6a.svg";